import { useEffect } from 'react';
import { useToast } from '../../../providers/ToastProvider';
import { apiErrorMessage } from '../../../utils/apiError';

export function useLoadErrorToast(isError: boolean, error: unknown, fallback: string): void {
    const { showToast } = useToast();
    useEffect(() => {
        if (isError) showToast(apiErrorMessage(error, fallback), 'error');
    }, [isError, error, fallback, showToast]);
}
